import { observer } from 'mobx-react';
import { T } from '../../../Translations';
import CountStore from '../CountStore';
import { useSegment } from '../Segment';
import PrimaryAction from './PrimaryAction';
import SegmentedControl from './SegmentedControl';

interface Props {
  participantsCount: CountStore;
  groupsCount: CountStore;
}

function TitleRow({ participantsCount, groupsCount }: Props) {
  const segment = useSegment();

  return (
    <div className="flex flex-wrap items-center justify-between gap-4 px-2.5 lg:px-12">
      <div className="flex min-w-0 flex-wrap items-center gap-5">
        <h1
          className="text-foreground"
          style={{ fontSize: 'var(--text-2xl)', fontWeight: 'var(--font-weight-semibold)' }}
        >
          <T kind="People" />
        </h1>
        <SegmentedControl
          segment={segment}
          participantsCount={participantsCount}
          groupsCount={groupsCount}
        />
      </div>
      <PrimaryAction segment={segment} />
    </div>
  );
}

export default observer(TitleRow);
